




























import {Component} from 'vue-property-decorator';
import {Mixins} from 'vue-mixin-decorator';
import {BaseComponent} from '@/mixins/BaseComponent';

import {IpMode} from '@/model/network/IpMode';

@Component({
  components: {},
})
export default class NetworkIpTabs extends Mixins<BaseComponent>(BaseComponent) {

  private IpMode = IpMode;

  private value: IpMode = IpMode.IPv4;
}
